// GDPR S8.5b — statusul afișat pe fișa CRM pentru ultimul job Mailjet al unui punct email (contract S8 §9).
// Proprietarul canonic al maparii listelor: „Liste → scopuri” (admin) sau „Scopurile comunicărilor Mailjet” → „Liste”
// (manager Privacy); fiecare panou citește propriul parametru, deci același deep-link duce exact acolo.
export const MAILJET_LIST_MAPPING_ROUTE = Object.freeze({
  path: "/ncrm/data-integrations",
  query: Object.freeze({ tab: "mailjet", mailjetView: "lists", mailjetPanel: "privacyLists" }),
});

const SKIP_STATUS = Object.freeze({
  no_mapped_lists: "unmapped",
  not_in_mailjet: "notInMailjet",
  account_disabled: "accountDisabled",
  no_active_account: "accountDisabled",
});

// `state_changed` / `point_unavailable`: nimic de propagat, deci „Sincronizat”.
export const syncStatusKey = (row = {}) => {
  if (!row.status) return "none";
  if (row.status === "succeeded") return "synced";
  if (row.status === "failed") return "failed";
  if (row.status === "skipped") return SKIP_STATUS[row.reason_code] || "synced";
  return row.last_error_code === "account_identity_unknown" ? "accountUnverified" : "inProgress";
};

export const SYNC_STATUS_STYLE = Object.freeze({
  synced: { color: "success", icon: "mdi-check-circle-outline" },
  inProgress: { color: "info", icon: "mdi-progress-clock" },
  failed: { color: "error", icon: "mdi-alert-circle-outline" },
  unmapped: { color: "warning", icon: "mdi-format-list-bulleted" },
  notInMailjet: { color: "default", icon: "mdi-email-off-outline" },
  accountDisabled: { color: "warning", icon: "mdi-account-cancel-outline" },
  accountUnverified: { color: "warning", icon: "mdi-account-question-outline" },
  none: { color: "default", icon: "mdi-minus-circle-outline" },
});

// Când se recitește lista: un job `pending` neevaluat sau reprogramat de worker (`active`, backoff 1m…24h) se urmărește
// până după scadența lui; unul evaluat în `dry_run` (`dry_run_at`) poate fi procesat după trecerea pe `active`, deci se
// urmărește și el, dar numai în ritmul lent (`slowMs`).
export const nextPollDelay = (items = [], { everyMs = 15000, slowMs = 5 * 60000, now = Date.now() } = {}) => {
  const waits = items.filter((item) => item.status === "pending").map((item) => {
    if (item.dry_run_at) return slowMs;
    const ms = new Date(item.next_attempt_at).getTime() - now;
    return (Number.isFinite(ms) ? Math.max(ms, 0) : 0) + everyMs;
  });
  return waits.length ? Math.min(...waits) : null;
};

export const formatSyncDate = (value) => {
  const date = value ? new Date(value) : null;
  if (!date || Number.isNaN(date.getTime())) return "";
  const pad = (part) => String(part).padStart(2, "0");
  return `${pad(date.getDate())}.${pad(date.getMonth() + 1)}.${date.getFullYear()}, ${pad(date.getHours())}:${pad(date.getMinutes())}`;
};
